module.exports = __webpack_public_path__ + "static/media/Item 2.a6cdd246.svg";